import { render, staticRenderFns } from "./ImgWithBG.vue?vue&type=template&id=4f620801&scoped=true&"
import script from "./ImgWithBG.vue?vue&type=script&lang=js&"
export * from "./ImgWithBG.vue?vue&type=script&lang=js&"
import style0 from "./ImgWithBG.vue?vue&type=style&index=0&id=4f620801&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f620801",
  null
  
)

export default component.exports